// extracted by mini-css-extract-plugin
module.exports = {"bar-style":"_5D3qn0oy","header":"_5D2plGl6","title":"_5Dm0ynJF","subtitle":"_5D2pNl0A","main":"_5D1c7XO4","already":"_5DfVrhCo","already__link":"_5D343-F-"};